import axios from 'axios'
import {BASE_URL} from '../ApiService/ApiConfig.js'

let token = localStorage.getItem('jwt');
if (token) {
    token = token.replaceAll('"', '');
}

let config = {
    headers: {
        'Content-Type': "application/json",
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Authorization': 'Bearer ' + token
    }

}

export class OperadorService {

    async getListaMonitoreoDets() {

        return await axios.get(`${BASE_URL}/monitoreo/estado/Activo`    ,
            config
        ).then(res => res.data.data);
    }

    async getListaMonitoreoDetsXnumeroAlertas(numeroAlertas) {

        return await axios.get(`${BASE_URL}/monitoreo/estado/Activo/numero-alertas/` + numeroAlertas,
            config
        ).then(res => res.data.data);
    }

    async getListaMonitoreoDetsXUsuarioYnumeroAlertas(username, numeroAlertas) {

        return await axios.get(`${BASE_URL}/monitoreo/estado/Activo/usuario/` + username + '/numero-alertas/' + numeroAlertas,
            config
        ).then(res => res.data.data);
    }

    async  getListaEstadoProceso() {

        return await axios.get(`${BASE_URL}/configuracion/configuracion-det/configuracion-cab/codigo/BIT-0000-0001`,
            config
        ).then(res => res.data.data);
    }

    async  getListaNovedad() {

        return await axios.get(`${BASE_URL}/configuracion/jerarquia/principal/23fd3/secundario/sfsdf/hijo/NOVEDADES`,
            config
        ).then(res => res.data.data);
    }


}

